/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

/**
 * @description Saved preferences, or null when none have been saved yet
 */
export const getPreferences200Schema = z.object({
    "preferences": z.nullable(z.object({
    "userVertical": z.nullable(z.string()),
"sections": z.array(z.object({
    "name": z.string(),
"statements": z.array(z.string())
    }))
    }))
    })

export const getPreferencesQueryResponseSchema = z.lazy(() => getPreferences200Schema)